// @ts-nocheck
import * as R from 'ramda';
import BigcapitalLoading from './BigcapitalLoading';
import withDashboard from '@/containers/Dashboard/withDashboard';

const containerStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '70vh',
  margin: 0,
};

const headingStyle = {
  fontSize: '2em',
  color: 'grey'
};

function SplashScreenComponent({ splashScreenLoading }) {
  //return splashScreenLoading ? <BigcapitalLoading /> : null;
  return splashScreenLoading ? <div style={containerStyle}>
    <h1 style={headingStyle}>Loading account module..</h1>
  </div> : null;
}

export const SplashScreen = R.compose(
  withDashboard(({ splashScreenLoading }) => ({
    splashScreenLoading,
  })),
)(SplashScreenComponent);
